import { userAgents } from 'lighthouse/core/config/constants'

const userAgent = typeof window !== 'undefined' ? window.navigator.userAgent : null

const mobileDevices = [
  /Android/i,
  /webOS/i,
  /iPhone/i,
  /iPad/i,
  /iPod/i,
  /BlackBerry/i,
  /Windows Phone/i,
]

export const isLightHouse = userAgents.desktop === userAgent || userAgents.mobile === userAgent

export const isMobile = mobileDevices.some((toMatchItem) => {
  return userAgent?.match(toMatchItem)
})
